import { trackBoardsProductRemoveFromBoardSubmit } from "@faire/web-api/events/boards/submit/productRemoveFromBoard";
import { trackBoardsProductSaveToBoardSubmit } from "@faire/web-api/events/boards/submit/productSaveToBoard";
import { trackProductTileHeartClick } from "@faire/web-api/events/productTile/click/heart";
import { trackProductTileQuantityPickerChooseOptionsClick } from "@faire/web-api/events/productTile/click/quantityPickerChooseOptions";
import { trackProductTileQuantityPickerExpandClick } from "@faire/web-api/events/productTile/click/quantityPickerExpand";
import { trackProductTileChooseOptionsQuantityUpdateButtonSubmit } from "@faire/web-api/events/productTile/submit/chooseOptionsQuantityUpdateButton";
import { trackProductTileQuickAddUpdateQuantitySubmit } from "@faire/web-api/events/productTile/submit/quickAddUpdateQuantity";
import { ProductTileContainer } from "@faire/web-api/indigofair/data/ProductTileContainer";
import { isNullish } from "@faire/web/common/typescriptUtils";

import { ILeanProductTile } from "@faire/retailer/features/MarketplaceItems/MarketplaceProduct/LeanProtos/ILeanProductTile";
import { Category } from "@faire/retailer/models/Category/Category";

export const onQuickAddUpdate =
  (requestId?: string, category?: Category) =>
  (
    product?: ILeanProductTile.ILeanProduct,
    onClickEventName?: string,
    newQuantity?: number
  ) => {
    const eventContextString = getEventContextString(
      onClickEventName,
      category
    );
    if (eventContextString && product && !isNullish(newQuantity)) {
      trackProductTileQuantityPickerExpandClick(
        eventContextString,
        requestId ?? "",
        product.token ?? "",
        product?.promoted_by.join(" ") ?? "",
        product.impression_id ?? ""
      );
      trackProductTileQuickAddUpdateQuantitySubmit(
        eventContextString,
        requestId ?? "",
        product.token ?? "",
        product?.promoted_by.join(" ") ?? "",
        newQuantity.toString(),
        product.impression_id ?? ""
      );
    }
  };

export const onChooseOption =
  (requestId?: string, category?: Category) =>
  (product?: ILeanProductTile.ILeanProduct, onClickEventName?: string) => {
    const eventContextString = getEventContextString(
      onClickEventName,
      category
    );
    if (eventContextString && product) {
      trackProductTileQuantityPickerChooseOptionsClick(
        eventContextString,
        requestId ?? "",
        product.token ?? "",
        product?.promoted_by.join(" ") ?? "",
        product.impression_id ?? ""
      );
    }
  };

export const onChooseOptionQuantityUpdate =
  (requestId?: string, category?: Category) =>
  (
    product?: ILeanProductTile.ILeanProduct,
    onClickEventName?: string,
    newQuantity?: number
  ) => {
    const eventContextString = getEventContextString(
      onClickEventName,
      category
    );
    if (eventContextString && product && !isNullish(newQuantity)) {
      trackProductTileChooseOptionsQuantityUpdateButtonSubmit(
        eventContextString,
        requestId ?? "",
        product.token ?? "",
        product?.promoted_by.join(" ") ?? "",
        newQuantity.toString(),
        product.impression_id ?? ""
      );
    }
  };

export const onClickHeart =
  (requestId?: string, category?: Category) =>
  (product?: ILeanProductTile.ILeanProduct, onClickEventName?: string) => {
    const eventContextString = getEventContextString(
      onClickEventName,
      category
    );
    if (eventContextString && product) {
      trackProductTileHeartClick(
        eventContextString,
        requestId ?? "",
        product.token ?? "",
        product?.promoted_by.join(" ") ?? "",
        product.impression_id ?? ""
      );
    }
  };

export const onSaveToBoard =
  (requestId?: string, category?: Category) =>
  (
    product?: ILeanProductTile.ILeanProduct,
    onClickEventName?: string,
    boardToken?: string
  ) => {
    const eventContextString = getEventContextString(
      onClickEventName,
      category
    );
    if (eventContextString && product && boardToken) {
      trackBoardsProductSaveToBoardSubmit(
        eventContextString,
        requestId ?? "",
        product.token ?? "",
        product?.promoted_by.join(" ") ?? "",
        boardToken,
        product.impression_id ?? ""
      );
    }
  };

export const onRemoveFromBoard =
  (requestId?: string, category?: Category) =>
  (
    product?: ILeanProductTile.ILeanProduct,
    onClickEventName?: string,
    boardToken?: string
  ) => {
    const eventContextString = getEventContextString(
      onClickEventName,
      category
    );
    if (eventContextString && product && boardToken) {
      trackBoardsProductRemoveFromBoardSubmit(
        eventContextString,
        requestId ?? "",
        product.token ?? "",
        product?.promoted_by.join(" ") ?? "",
        boardToken,
        product.impression_id ?? ""
      );
    }
  };

const getEventContextString = (
  onClickEventName: string | undefined,
  category?: Category
) => {
  if (onClickEventName) {
    return category
      ? `${ProductTileContainer.CATEGORY_PRODUCT_RESULTS_LAYOUT_ELEMENT_CAROUSEL}|${category?.mostSpecificPathIdentifier}|${onClickEventName}`
      : `${ProductTileContainer.HOMEPAGE_LAYOUT_ELEMENT_CAROUSEL}|${onClickEventName}`;
  }
  return;
};
